import { useHookstate } from "@hookstate/core";
import { EventType } from "../../../misc/types";
import { PsychologyListControls } from "./PsychologyListControls";
import { psychologistAppointmentFormats, psychologistListTableColumns } from "../../../misc/constants";
import { Avatar } from "../../../components/Avatar";
import { MainUser, MainUserJsonSavedData } from "../../../types";
import React from "react";
import { getDateOnly } from "../../../misc/utils";
import Info from "../../../assets/icons/Info";

type PsychologyListType = {
  localEvents: EventType[];
  mode?: string;
};

export const PsychologyList = ({ localEvents, mode }: PsychologyListType) => {
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const form = state.form || {};

  const filteredEvents = localEvents.filter(e => {
    let retValue = true;

    if (form.search) {
      const searchLc = form.search.toLowerCase()
      retValue = retValue && Boolean(e.client?.firstname?.toLowerCase().includes(searchLc) || e.client?.lastname?.toLowerCase().includes(searchLc) || e.client?.email?.toLowerCase().includes(searchLc))
    }

    if (form.start_date) {
      retValue = retValue && e.day >= form.start_date
    }

    if (form.end_date) {
      retValue = retValue && e.day <= form.end_date
    }

    if (parseInt(form.format)) {
      retValue = retValue && e.appointment?.format === parseInt(form.format)
    }

    return retValue;
  }).sort((a, b) => a.day.getTime() - b.day.getTime())

  return (
    <div className="flex flex-col flex-1 bg-white rounded-md p-4">
      <PsychologyListControls parentState={localState} />
      <table className="w-full border-collapse mt-4 rounded-lg overflow-hidden text-md">
        <thead>
          <tr>
            {psychologistListTableColumns.map((column) => (
              <th
                key={column}
                className={`px-4 py-2 border-b text-left`}
              >
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filteredEvents.map(e => {
            const foundFormat = psychologistAppointmentFormats.find(f => f.value === e.appointment?.format) || psychologistAppointmentFormats[0];
            const Icon = foundFormat.Icon;
            return (
              <tr>
                <td className="px-4 py-2 border-b">
                  <div className="flex flex-row items-center gap-3">
                    {e.client?.id ? (
                      <React.Fragment>
                        <Avatar user={{ json_saved_data: e.client } as MainUser} />
                        <span className="font-medium text-[15px] leading-[19.5px] text-valley-black">
                          {e.client.firstname} {e.client.lastname}
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <div className="w-10 h-10 bg-valley-background-blue rounded-full" />
                        <span className="font-medium text-[15px] leading-[19.5px] text-[#D2D8E5]">
                          -
                        </span>
                      </React.Fragment>
                    )}
                  </div>
                </td>
                <td className="px-4 py-2 border-b">
                  {getDateOnly(e.day)}
                </td>
                <td className="px-4 py-2 border-b">
                  {e.start}-{e.end}
                </td>
                <td className="px-4 py-2 border-b">
                  <div className='flex flex-row items-center gap-2'>
                    <Icon />
                    <span className={`font-medium text-[15px] leading-[19.5px] ${foundFormat.textClassName}`}>
                      {foundFormat.label}
                    </span>
                  </div>
                </td>
                <td className="px-4 py-2 border-b">
                  <div className="flex flex-row">
                    <button className="flex flex-row items-center justify-center bg-valley-background-blue rounded-md p-1.5">
                      <Info />
                    </button>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}